import AppApi from "@/api/AppApi";
import { apiErrorToAlert } from "@/utils/Errorhandler";

export default {
  //   getAktivitaeten(params) {
  //     return Api.get("aktivitaet/", { params });
  //   },

  createAktivitaet(data, instance) {
    instance.pendenzenIsBusy = true;

    if (data.typ == null || data.typ == "") data.typ = "17FD0A66AD0"

    AppApi.post("aktivitaet/", data)
      .then((response) => {
        instance.getAktivitaeten();
        instance.$bus.$emit("prozess-sidebar-reload");
        instance.pendenzenLadeFehler = false;

        instance.$notify({
          type: "success",
          title: instance.$t("global.actionsuccessful"),
          text: instance.$t("global.activitysavedsuccessfully"),
        });
        instance.$bus.$emit("aktivitaet-modal-show", response.data);
      })
      .catch((e) => {
        instance.$notify(apiErrorToAlert(e));
        instance.pendenzenLadeFehler = true;
      })
      .finally(() => {
        instance.pendenzenIsBusy = false;
      });
  },

  async updateAktivitaet(data, instance) {
    instance.pendenzenIsBusy = true;
    
    delete data.prozess;

    AppApi.put("aktivitaet/", data)
      .then(() => {
        instance.getAktivitaeten();
        instance.$bus.$emit("prozess-sidebar-reload");
        instance.pendenzenLadeFehler = false;

        instance.$notify({
          type: "success",
          title: instance.$t("global.actionsuccessful"),
          text: instance.$t("global.activitysavedsuccessfully"),
        });
      })
      .catch((e) => {
        instance.$notify(apiErrorToAlert(e));
        instance.pendenzenLadeFehler = true;
      })
      .finally(() => {
        instance.pendenzenIsBusy = false;
      });
  },

  async deleteAktivitaet(ids, instance, params) {
    instance.pendenzenIsBusy = true;

    AppApi.delete("aktivitaet/", { data: ids, params })
      .then(() => {
        instance.getAktivitaeten();
        instance.$bus.$emit("prozess-sidebar-reload");
        instance.pendenzenLadeFehler = false;

        instance.$notify({
          type: "success",
          title: instance.$t("global.actionsuccessful"),
          text: instance.$t("global.activitydeleted"),
        });
      })
      .catch((e) => {
        instance.$notify(apiErrorToAlert(e));
        instance.pendenzenLadeFehler = true;
      })
      .finally(() => {
        instance.pendenzenIsBusy = false;
      });
  },
};
